import { createFileRoute } from '@tanstack/react-router';
import { CallsModal } from '../../../../../../components/buyers/calls/callsModal';

export const Route = createFileRoute(
    '/_app/buyers/$buyerId/_buyerLayout/calls/$callId',
)({
    loader: ({ params }) => ({
        buyerId: params.buyerId,
        callId: params.callId,
    }),
    component: CallsModalWrapper,
})

function CallsModalWrapper() {
    const { buyerId, callId } = Route.useLoaderData();

    return (
        <CallsModal
            openDialog={true}
            callId={callId}
            buyerId={buyerId}
        />
    );
}
